<template>
  <div>
    <v-content>
      <v-container>
        <v-file-input
          v-model="brouche"
          required
          counter
          show-size
          label="Select File..."
          accept="application/pdf"
          @change="uploadImage"
        ></v-file-input>
        <!-- <img class="empImg" v-if="imgurl != null" :src="imgurl" alt="" /> <br /> -->
        <v-btn color="primary" @click="onUpload" :disabled="Employee.length > 0"
          >Upload</v-btn
        >
        <h3>Current File</h3>
        <div v-if="Employee.length > 0">
          <span v-for="(emp, index) in Employee" :key="index">
            <!-- <img class="empImg" :src="emp.file" alt="" /> <br /> -->
            <!-- <iframe
              :src="returnurl(emp.file)"
              frameborder="0"
              height="500px"
              width="100%" -->
              <iframe :src=emp.file
                width="800" height="600">
            ></iframe>
            <v-btn color="primary" @click="onDelete(emp.file, emp)"
              >Delete <v-icon class="delete">mdi-delete</v-icon></v-btn
            >
          </span>
        </div>
        <div v-else>
            <h1 style="text-align:center">No File to view</h1>
        </div>
      </v-container>
    </v-content>
    <v-snackbar top v-model="snackbar">
      {{ text }}
    </v-snackbar>
  </div>
</template>
<script>
import { fb, db } from "../firebase.js";

export default {
  name: "Broucher",
  data: () => ({
    snackbar: false,
    text: "",
    brouche: null,
    url:"http://docs.google.com/gview?url=",
    imgurl: null,
    Employee: [],
    broucher: {
      name: null,
      file: null,
    },
  }),
  methods: {
    onUpload() {
      if (this.brouche != null) {
        console.log(this.brouche);
        //   return
        var storageRef = fb.storage().ref("Broucher/" + this.broucher.name);
        let uploadTask = storageRef.put(this.brouche);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            console.log(snapshot);
          },
          (error) => {
            console.log(error);
            // Handle unsuccessful uploads
          },
          () => {
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
              this.broucher.file = downloadURL;
              console.log("File available at", downloadURL);
              db.collection("Broucher")
                .doc('broucher')
                .set(this.broucher)
                .catch(function (error) {
                  console.error("Error adding document: ", error);
                });
            });
          }
        );
        this.text = "Broucher added";
        this.snackbar = true;
        this.image = null;
        this.imgurl = null;
        this.employee.image = null;
        this.employee.name = null;
      } else {
        alert("Add a file");
      }
    },
    returnurl(img){
        var imgs = img
        var text = this.url.concat(imgs)
        var final = text.concat("&embedded=true")
        console.log(final)
        return final
    },
    onDelete(img, doc) {
      console.log(img);
      console.log(doc);
      let ref = fb.storage().refFromURL(img);
      console.log(ref);
      ref
        .delete()
        .then(function () {
          console.log("image deleted");
        })
        .catch(function (error) {
          // Uh-oh, an error occurred!err
          console.log(error);
          console.log("an error occurred");
        });
      this.$firestore.Employee.doc(doc[".key"])
        .delete()
        .then(() => {
          this.text = "file deleted";
          this.snackbar = true;
        });
    },
    uploadImage() {
      if (this.brouche === null) {
        this.imgurl = null;
      }
      this.broucher.name = this.brouche.name;
      this.imgurl = URL.createObjectURL(this.brouche);
      console.log(this.imgurl);
    },
  },
  firestore() {
    return {
      Employee: db.collection("Broucher"),
    };
  },
};
</script>
<style lang="scss" scoped>
.v-icon {
  color: #fff !important;
}
.empImg {
  width: 500px;
}
</style>
